import { classes } from './dnd-styles.st.css.js';
export default {
    item: classes.item,
    itemPlaceholder: classes.itemPlaceholder,
    itemPreview: classes.itemPreview,
    list: classes.list,
    gridItemPlaceholder: classes.gridItemPlaceholder,
    isInitialPositionToDrop: classes.isInitialPositionToDrop,
    gridItemPreview: classes.gridItemPreview,
    withGridItemStrip: classes.withGridItemStrip,
    withGridItemStripRight: classes.withGridItemStripRight,
};
//# sourceMappingURL=dnd-styles.js.map